import { render, staticRenderFns } from "./EditShow.vue?vue&type=template&id=8b73920e&"
import script from "./EditShow.vue?vue&type=script&lang=js&"
export * from "./EditShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports